module.exports = {
          srcSet: __webpack_public_path__ + "1833f15a77dbbb20f90091adc3d69d5e-1920.jpg"+" 1920w",
          images:[ {path: __webpack_public_path__ + "1833f15a77dbbb20f90091adc3d69d5e-1920.jpg",width: 1920,height: 50}],
          src: __webpack_public_path__ + "1833f15a77dbbb20f90091adc3d69d5e-1920.jpg",
          toString:function(){return __webpack_public_path__ + "1833f15a77dbbb20f90091adc3d69d5e-1920.jpg"},
          
          width: 1920,
          height: 50
        }